import { render, staticRenderFns } from "./CalendarItem.vue?vue&type=template&id=256c9304&"
import script from "./CalendarItem.vue?vue&type=script&lang=js&"
export * from "./CalendarItem.vue?vue&type=script&lang=js&"
import style0 from "./CalendarItem.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CalendarItem.vue?vue&type=style&index=1&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports